import { jsxs as s, jsx as l } from "react/jsx-runtime";
import { S as o } from "./types-b577bf77.mjs";
function g({
  title: n,
  titleId: i,
  size: r,
  height: c,
  width: a,
  ...h
}) {
  const e = r ? o[r] : o.s;
  return /* @__PURE__ */ s(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: r ? e : c || e,
      width: r ? e : a || e,
      "aria-labelledby": i,
      ...h,
      children: [
        n ? /* @__PURE__ */ l("title", { id: i, children: n }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Cancel-close_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M38.52 36 54 51.48 51.48 54 36 38.52 20.52 54 18 51.48 33.48 36 18 20.52 20.52 18 36 33.48 51.48 18 54 20.52 38.52 36Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Cancel-close_svg__a", children: /* @__PURE__ */ l("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
export {
  g as S
};
